import { UNASSIGNED_VALUE as GLOBAL_UNASSIGNED_VALUE } from 'modules/common/smartComponents/const';

export const CREATE_NEW_ACCOUNT = 'CREATE_NEW_ACCOUNT';
export const UNASSIGNED_VALUE = GLOBAL_UNASSIGNED_VALUE;
